<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-boxes">
      <translate>Shipments</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" :to="{name: 'ShippingsCreate'}">
          <font-awesome-icon icon="plus-circle" />
          <translate>New Shipment</translate>
        </b-button>
        <b-button variant="secondary" size="sm" :to="{name: 'ShippingsBulkImport'}" v-translate>Bulk Shipments Import</b-button>
      </template>
    </page-title>

    <api-list type="shippings" :model="models.shippings" :quick-filters="quickFiltersSetup.shippings" />

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ShippingsList',
  title() {
    return this.$gettext('Shipments')
  },
  components: {
    ApiList
  },
  props: {
    type: {
      type: String,
      default: 'shippings'
    }
  }
}
</script>
